<template lang="pug">
div(:class="[spacingClasses, { 'relative': $storyblok.isEditing }]")
    Subscribe(
        :formName="data.formName"
        :placeholderText="data.placeholderText"
        :buttonColor="data.buttonColor"
        :buttonClass="[fontColorClasses, { 'md:px-12': data.buttonText }]"
    )
        template(v-if="data.buttonText") {{ data.buttonText }}
    //- Shade for storyblok editor to prevent clicks
    div(
        v-if="$storyblok.isEditing"
        class="absolute inset-0 z-50"
    )
</template>

<script>
import Subscribe from '@/components/subscribe/'
import { generateGapClasses, generateFontColorClass } from '../../../helpers'

export default {
    name: 'SubscribeWidget',
    components: { Subscribe },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        spacingClasses() {
            return generateGapClasses(
                this.data.mobileSpacing,
                this.data.tabletSpacing,
                this.data.desktopSpacing
            )
        },
        fontColorClasses() {
            return generateFontColorClass(this.data.buttonFontColor)
        },
    },
}
</script>
